import { scrollToElement } from '@/scopes/common/infrastructure/dom/scrollToElement'
import { SEARCH_ELEMENT_ID } from '@/scopes/search/search/domain/constants'

export function scrollToSearchElementDelayed() {
  setTimeout(() => {
    scrollToElement(SEARCH_ELEMENT_ID)
  }, 250)
}
